module.exports = __webpack_public_path__ + "img/00042.6ba5f226.webp";